import { FeatureFlag } from '../FeatureFlag';

export const enableOrderDebugFirmFilter = new FeatureFlag({
    key: 'enable-order-debug-firm-filter',
    defaultValue: false,
});
